import { TagValueInfo, useAuthContext, UsersApi } from '@pull/pull-groupm-csp-api';
import { FC, useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import {useQuery} from 'react-query'
import TagValueEditModalForm from './TagEditModal';

type Props = {
  showModal: boolean
}

const TagEditModalFormWrapper: FC<Props> = ({ showModal}) => {
  const modalRoot = document.getElementById("modal-root") as HTMLElement


  if (showModal) {
    return ReactDOM.createPortal(<TagValueEditModalForm />,modalRoot)
  }

  return null
}

export {TagEditModalFormWrapper}
